module.exports = __webpack_public_path__ + "media/site/images/products/saas_ceodash-screen2-518dcfc302ea16e7c3c6ec1078c15769.png";